import { render } from "./MerchantProfileCreateModal.vue?vue&type=template&id=2243642b"
import script from "./MerchantProfileCreateModal.vue?vue&type=script&lang=js"
export * from "./MerchantProfileCreateModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./MerchantProfileCreateModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_881c333e%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fmerchant_profiles%2FMerchantProfileCreateModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__